export const COLOR_PURPLE_DEEP = '#251134';
export const COLOR_PURPLE_DEEP_1 = '#C4BEC8';
export const COLOR_PURPLE_DEEP_2 = '#9C93A3';
export const COLOR_PURPLE_DEEP_3 = '#74687E';
export const COLOR_PURPLE_DEEP_4 = '#4D3C59';

export const COLOR_PURPLE_LIGHT = '#A674E8';
export const COLOR_PURPLE_LIGHT_1 = '#EADAFB';
export const COLOR_PURPLE_LIGHT_2 = '#BE9AEE';
export const COLOR_PURPLE_LIGHT_3 = '#7451A2';
export const COLOR_PURPLE_LIGHT_4 = '#422E5D';

export const COLOR_PURPLE_LIGHT_SOFT = 'rgba(166, 116, 232, 0.12)';
export const COLOR_PURPLE_LIGHT_SOFT_STRONG = 'rgba(166, 116, 232, 0.18)';
export const COLOR_PURPLE_LIGHT_BORDER = 'rgba(166, 116, 232, 0.32)';
export const COLOR_PURPLE_LIGHT_GLOW = '0 0 24px rgba(166, 116, 232, 0.35)';

export const COLOR_GREEN = '#80E19F';
export const COLOR_GREEN_1 = '#EAF7EC';
export const COLOR_GREEN_2 = '#A9DFB5';
export const COLOR_GREEN_3 = '#60946B';
export const COLOR_GREEN_4 = '#293F2E';
export const COLOR_GREEN_SOFT = 'rgba(128, 225, 159, 0.12)';
export const COLOR_GREEN_BORDER = 'rgba(128, 225, 159, 0.30)';
export const COLOR_GREEN_GLOW = '0 0 20px rgba(128, 225, 159, 0.30)';

export const COLOR_PERIWINKLE = '#6178FF';
export const COLOR_PERIWINKLE_1 = '#E2E6FF';
export const COLOR_PERIWINKLE_2 = '#8C9DFF';
export const COLOR_PERIWINKLE_3 = '#3A4899';
export const COLOR_PERIWINKLE_4 = '#1D244D';
export const COLOR_PERIWINKLE_SOFT = 'rgba(97, 120, 255, 0.12)';
export const COLOR_PERIWINKLE_BORDER = 'rgba(97, 120, 255, 0.30)';
export const COLOR_PERIWINKLE_GLOW = '0 0 22px rgba(97, 120, 255, 0.35)';

export const COLOR_YELLOW = '#FCD770';
export const COLOR_YELLOW_1 = '#FEF8E5';
export const COLOR_YELLOW_2 = '#FDE297';
export const COLOR_YELLOW_3 = '#B0964E';
export const COLOR_YELLOW_4 = '#322B16';
export const COLOR_YELLOW_SOFT = 'rgba(252, 215, 112, 0.12)';
export const COLOR_YELLOW_BORDER = 'rgba(252, 215, 112, 0.30)';

export const COLOR_ORANGE = '#FF9C5F';
export const COLOR_ORANGE_1 = '#FFEDE2';
export const COLOR_ORANGE_2 = '#FFB78B';
export const COLOR_ORANGE_3 = '#B26D42';
export const COLOR_ORANGE_4 = '#4D2F1D';
export const COLOR_ORANGE_SOFT = 'rgba(255, 156, 95, 0.12)';
export const COLOR_ORANGE_BORDER = 'rgba(255, 156, 95, 0.30)';

export const COLOR_RED = '#FF5C5C';
export const COLOR_RED_1 = '#FFE1E1';
export const COLOR_RED_2 = '#FF8888';
export const COLOR_RED_3 = '#993737';
export const COLOR_RED_4 = '#331212';
export const COLOR_RED_SOFT = 'rgba(255, 92, 92, 0.12)';
export const COLOR_RED_BORDER = 'rgba(255, 92, 92, 0.30)';
export const COLOR_RED_GLOW = '0 0 22px rgba(255, 92, 92, 0.35)';

export const COLOR_NEUTRAL = '#F6F6F6';
export const COLOR_NEUTRAL_1 = '#FFFFFF';
export const COLOR_NEUTRAL_2 = '#A9A9A9';
export const COLOR_NEUTRAL_3 = '#616161';
export const COLOR_NEUTRAL_4 = '#181818';

// Resting state is the brand accent purple; hover/active darken from there.
export const COLOR_PRIMARY = COLOR_PURPLE_LIGHT;
export const COLOR_PRIMARY_HOVER = COLOR_PURPLE_LIGHT_3;
export const COLOR_PRIMARY_ACTIVE = COLOR_PURPLE_LIGHT_4;
export const COLOR_PRIMARY_LIGHT = COLOR_PURPLE_LIGHT_SOFT;

export const COLOR_SECONDARY = COLOR_PURPLE_DEEP;
export const COLOR_SECONDARY_HOVER = COLOR_PURPLE_DEEP_4;
export const COLOR_SECONDARY_ACTIVE = COLOR_PURPLE_DEEP;

export const COLOR_ACCENT = COLOR_GREEN;

export const COLOR_SUCCESS = COLOR_GREEN;
export const COLOR_SUCCESS_LIGHT = COLOR_GREEN_SOFT;
export const COLOR_WARNING = COLOR_ORANGE;
export const COLOR_WARNING_LIGHT = COLOR_ORANGE_SOFT;
export const COLOR_ERROR = COLOR_RED;
export const COLOR_ERROR_LIGHT = COLOR_RED_SOFT;
export const COLOR_INFO = COLOR_PERIWINKLE;
export const COLOR_INFO_LIGHT = COLOR_PERIWINKLE_SOFT;

export const COLOR_BG_BASE = COLOR_PURPLE_DEEP;
export const COLOR_BG_SUBTLE = COLOR_PURPLE_DEEP_4;
export const COLOR_BG_MUTED = 'rgba(255, 255, 255, 0.08)';
export const COLOR_BG_ELEVATED = 'rgba(255, 255, 255, 0.026)';
export const COLOR_BG_ELEVATED_SOLID = COLOR_PURPLE_DEEP_4;
export const COLOR_BG_OVERLAY = 'rgba(37, 17, 52, 0.80)';
export const COLOR_BG_GLASS = 'rgba(37, 17, 52, 0.72)';
export const COLOR_BG_SIDEBAR = '#1E0E2A';
// Solid equivalent of COLOR_BG_ELEVATED (rgba(255,255,255,0.026)) composited
// over COLOR_BG_BASE (#251134) — used where a modal needs an opaque surface
// rather than the translucent elevated token itself.
export const COLOR_BG_MODAL = '#2B1739';
// Solid equivalents of the table's own surfaces, for a sticky (fixed) column.
// That column has the scrolling columns passing underneath it, so a translucent
// background would let them show through.
//
// COLOR_BG_TABLE_STICKY matches the header row, so the pinned column reads as
// one continuous band: COLOR_BG_MUTED (rgba(255,255,255,0.08)) over
// COLOR_BG_ELEVATED (rgba(255,255,255,0.026)) over COLOR_BG_BASE (#251134)
// resolves to #3C2A49. _HOVER is one more COLOR_BG_MUTED pass on top of that
// (#4C3B58, i.e. Dark Purple 4 to within a rounding step), so a hovered row
// still shifts in the pinned column as it does everywhere else.
export const COLOR_BG_TABLE_STICKY = '#3C2A49';
export const COLOR_BG_TABLE_STICKY_HOVER = COLOR_PURPLE_DEEP_4;

// Shared hover-state opacity for menu/dropdown items — combine with a base
// hue via color-mix(in srgb, <hue> calc(var(--opacity-hover-strong) * 100%),
// transparent) rather than hardcoding a one-off translucent color per item
// (see UserMenu.module.scss's .item/.itemDanger hover rules).
export const OPACITY_HOVER_STRONG = '0.12';

export const COLOR_TEXT_PRIMARY = COLOR_NEUTRAL;
export const COLOR_TEXT_SECONDARY = 'rgba(246, 246, 246, 0.72)';
export const COLOR_TEXT_TERTIARY = 'rgba(246, 246, 246, 0.48)';
export const COLOR_TEXT_DISABLED = 'rgba(246, 246, 246, 0.28)';
export const COLOR_TEXT_INVERTED = COLOR_PURPLE_DEEP;
export const COLOR_TEXT_LINK = COLOR_PURPLE_LIGHT;
export const COLOR_TEXT_LINK_HOVER = COLOR_PURPLE_LIGHT_2;

export const COLOR_BORDER_SUBTLE = 'rgba(255, 255, 255, 0.06)';
export const COLOR_BORDER_DEFAULT = 'rgba(255, 255, 255, 0.10)';
export const COLOR_BORDER_STRONG = 'rgba(255, 255, 255, 0.18)';
export const COLOR_BORDER_FOCUS = COLOR_PURPLE_LIGHT;

export const FONT_FAMILY_SANS =
  "'Roboto Flex', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
export const FONT_FAMILY_HEADING =
  "'Roboto Serif', Georgia, 'Times New Roman', serif";
export const FONT_FAMILY_MONO =
  "'JetBrains Mono', 'Fira Code', 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace";

// Scale calibrated against the "Split Canvas" auth concept (2026 redesign) —
// noticeably tighter than the old scale (BASE was 16px/1rem). Every page's
// type now derives from this proportion; see apps/web/CLAUDE.md.
export const FONT_SIZE_2XS = '0.6875rem'; // 11px
export const FONT_SIZE_XS = '0.75rem'; // 12px
export const FONT_SIZE_SM = '0.8125rem'; // 13px
export const FONT_SIZE_BASE = '0.875rem'; // 14px
export const FONT_SIZE_MD = '0.9375rem'; // 15px
export const FONT_SIZE_LG = '1rem'; // 16px
export const FONT_SIZE_XL = '1.125rem'; // 18px
export const FONT_SIZE_2XL = '1.5rem'; // 24px
export const FONT_SIZE_3XL = '1.6875rem'; // 27px
export const FONT_SIZE_4XL = '2rem'; // 32px
export const FONT_SIZE_5XL = '2.5rem'; // 40px

export const FONT_SIZE_DISPLAY_MD = '2.5rem';
export const FONT_SIZE_DISPLAY_LG = '4rem';

// One-off, off-scale size requested specifically for the header's candidate
// nav links (MainLayout.module.scss's .candidateNavItem) — doesn't fit the
// FONT_SIZE_SM/BASE/MD scale steps above.
export const FONT_SIZE_NAV = '0.9125rem'; // 14.6px

// One-off, off-scale size requested specifically for AntD Modal's title
// (theme.ts's Modal.titleFontSize) — doesn't fit the FONT_SIZE_SM/BASE/MD
// scale steps above.
export const FONT_SIZE_MODAL_TITLE = '1.15rem'; // 18.4px

export const FONT_SIZE_TIMER = '1.625rem';
export const FONT_SIZE_TIMER_LABEL = '0.8125rem';

// One-off, off-scale sizes requested specifically for the Packages page's
// credit balance card (Packages.module.scss's .creditBalanceNumber/.creditBalanceUnit)
// — don't fit the FONT_SIZE_XL/2XL/3XL scale steps above.
export const FONT_SIZE_CREDIT_BALANCE = '2.25rem'; // 36px
export const FONT_SIZE_CREDIT_UNIT = '1.375rem'; // 22px
export const LINE_HEIGHT_DISPLAY = '1.05';

export const FONT_WEIGHT_LIGHT = '300';
export const FONT_WEIGHT_NORMAL = '400';
export const FONT_WEIGHT_MEDIUM = '500';
export const FONT_WEIGHT_SEMIBOLD = '600';
export const FONT_WEIGHT_BOLD = '700';
export const FONT_WEIGHT_EXTRABOLD = '800';

export const LINE_HEIGHT_TIGHT = '1.2';
export const LINE_HEIGHT_SNUG = '1.375';
export const LINE_HEIGHT_NORMAL = '1.5';
export const LINE_HEIGHT_RELAXED = '1.625';
export const LINE_HEIGHT_LOOSE = '2';

export const LETTER_SPACING_TIGHTER = '-0.04em';
export const LETTER_SPACING_TIGHT = '-0.02em';
export const LETTER_SPACING_NORMAL = '0';
export const LETTER_SPACING_WIDE = '0.025em';
export const LETTER_SPACING_WIDER = '0.05em';
export const LETTER_SPACING_WIDEST = '0.1em';

export const SPACING_0 = '0';
export const SPACING_PX = '1px';
export const SPACING_0_5 = '0.125rem';
export const SPACING_1 = '0.25rem';
export const SPACING_1_5 = '0.375rem';
export const SPACING_2 = '0.5rem';
export const SPACING_2_5 = '0.625rem';
export const SPACING_3 = '0.75rem';
export const SPACING_3_5 = '0.875rem';
export const SPACING_4 = '1rem';
export const SPACING_5 = '1.25rem';
export const SPACING_6 = '1.5rem';
export const SPACING_7 = '1.75rem';
export const SPACING_8 = '2rem';
export const SPACING_9 = '2.25rem';
export const SPACING_10 = '2.5rem';
export const SPACING_11 = '2.75rem';
export const SPACING_12 = '3rem';
export const SPACING_14 = '3.5rem';
export const SPACING_16 = '4rem';
export const SPACING_20 = '5rem';
export const SPACING_24 = '6rem';
export const SPACING_28 = '7rem';
export const SPACING_32 = '8rem';

export const RADIUS_NONE = '0';
export const RADIUS_SM = '0.25rem';
export const RADIUS_DEFAULT = '0.375rem';
export const RADIUS_MD = '0.6875rem'; // 11px — matches the auth concept's input/panel radius
export const RADIUS_LG = '0.75rem';
export const RADIUS_XL = '1rem';
export const RADIUS_2XL = '1.25rem';
export const RADIUS_3XL = '1.5rem';
export const RADIUS_FULL = '9999px';

export const SHADOW_NONE = 'none';
export const SHADOW_XS = '0 1px 2px 0 rgba(0, 0, 0, 0.35)';
export const SHADOW_SM = '0 2px 4px 0 rgba(0, 0, 0, 0.40)';
export const SHADOW_DEFAULT = '0 4px 12px -2px rgba(0, 0, 0, 0.45), 0 2px 4px -2px rgba(0, 0, 0, 0.35)';
export const SHADOW_MD = '0 8px 24px -4px rgba(0, 0, 0, 0.50), 0 4px 8px -4px rgba(0, 0, 0, 0.40)';
export const SHADOW_LG = '0 16px 40px -8px rgba(0, 0, 0, 0.55), 0 8px 16px -6px rgba(0, 0, 0, 0.45)';
export const SHADOW_XL = '0 24px 64px -12px rgba(0, 0, 0, 0.65)';
export const SHADOW_INNER = 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.30)';
// Edge shadow cast by a table's sticky (fixed) column over the columns
// scrolling underneath it. Same geometry antd uses, but antd draws it from
// `colorSplit` — a hairline divider colour — which against this dark surface
// reads as a faint line rather than a shadow, leaving the pinned column looking
// flat against the content passing behind it.
export const SHADOW_TABLE_STICKY = 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.55)';

export const SHADOW_GLOW_PRIMARY = COLOR_PURPLE_LIGHT_GLOW;
export const SHADOW_GLOW_SUCCESS = COLOR_GREEN_GLOW;
export const SHADOW_GLOW_INFO = COLOR_PERIWINKLE_GLOW;
export const SHADOW_GLOW_DANGER = COLOR_RED_GLOW;

export const SHADOW_FOCUS_RING = `0 0 0 3px ${COLOR_PURPLE_LIGHT_SOFT_STRONG}`;

/**
 * Glass surface — the "liquid glass" material from the v3 prototype.
 * Composed by the `glass-surface` SCSS mixin (see mixins.scss) and documented in
 * apps/web/CLAUDE.md ("Glass surface"). Edit these values to restyle every glass
 * surface at once; override the matching `--glass-*` CSS variables on an element
 * to vary a single instance. Keep each value a single-line string (no `;`/quotes
 * inside) — required by the design-tokens parser in vite.config.ts.
 */
export const GLASS_SURFACE = 'linear-gradient(140deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 38%, rgba(255,255,255,0.01) 68%, rgba(255,255,255,0.05) 100%)';
export const GLASS_BORDER_COLOR = 'rgba(255,255,255,0.06)';
// NOTE: the outer drop-shadows (`0 14px 36px …`, `0 2px 6px …`) were removed for now
// because they get cropped by scroll containers (e.g. the interview left panel).
// Only the inset edge highlights/depth remain. Re-add the drop layers when a
// containing-overflow solution is decided.
export const GLASS_SHADOW = 'inset 0 1px 0 rgba(255,255,255,0.22), inset 1px 1px 0 rgba(255,255,255,0.06), inset 0 -1px 0 rgba(0,0,0,0.32), inset -1px -1px 0 rgba(0,0,0,0.18), inset 0 0 26px rgba(166,116,232,0.05)';
export const GLASS_RING = 'conic-gradient(from -40deg at 50% 50%, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.18) 22%, rgba(255,255,255,0.35) 50%, rgba(255,255,255,0.18) 78%, rgba(255,255,255,0.55) 100%)';
export const GLASS_RING_OPACITY = '0.7';
export const GLASS_BLUR = '20px';
export const GLASS_TINT = 'transparent';

export const Z_INDEX_STICKY = '1020';
export const Z_INDEX_FIXED = '1030';
export const Z_INDEX_DROPDOWN = '1060';
export const Z_INDEX_POPOVER = '1060';
export const Z_INDEX_MODAL_BACKDROP = '1040';
export const Z_INDEX_MODAL = '1050';
export const Z_INDEX_TOOLTIP = '1070';
export const Z_INDEX_TOAST = '1080';

export const TRANSITION_DURATION_FAST = '150ms';
export const TRANSITION_DURATION_DEFAULT = '200ms';
export const TRANSITION_DURATION_SLOW = '300ms';
export const TRANSITION_DURATION_SLOWER = '500ms';
export const TRANSITION_DURATION_CHART = '900ms';

export const TRANSITION_TIMING_DEFAULT = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const TRANSITION_TIMING_LINEAR = 'linear';
export const TRANSITION_TIMING_IN = 'cubic-bezier(0.4, 0, 1, 1)';
export const TRANSITION_TIMING_OUT = 'cubic-bezier(0, 0, 0.2, 1)';
export const TRANSITION_TIMING_BOUNCE = 'cubic-bezier(0.68, -0.55, 0.265, 1.55)';
// Gentler overshoot than TRANSITION_TIMING_BOUNCE — for the Packages tier
// card's hover lift specifically (see Packages.module.scss's .tier:hover).
export const TRANSITION_TIMING_SPRING = 'cubic-bezier(0.34, 1.3, 0.64, 1)';

export const TRANSITION_COLORS = `color ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}, background-color ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}, border-color ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}`;
export const TRANSITION_OPACITY = `opacity ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}`;
export const TRANSITION_TRANSFORM = `transform ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}`;
export const TRANSITION_ALL = `all ${TRANSITION_DURATION_DEFAULT} ${TRANSITION_TIMING_DEFAULT}`;

export const CONTAINER_SM = '640px';
export const CONTAINER_MD = '768px';
export const CONTAINER_LG = '1024px';
export const CONTAINER_XL = '1280px';
export const CONTAINER_2XL = '1536px';
// Candidate/guest content column width — no Sider sets a natural width for
// these routes, so the page (and the header pill above it) cap and center
// instead of sprawling edge-to-edge. See Sessions.module.scss's `.page`.
export const CONTAINER_CONTENT = '900px';

export const SIDEBAR_WIDTH_COLLAPSED = '96px';
export const SIDEBAR_WIDTH_EXPANDED = '288px';

export const HEADER_HEIGHT = '64px';
export const HEADER_HEIGHT_COMPACT = '48px';

export const CONTROL_HEIGHT_XS = '24px';
export const CONTROL_HEIGHT_SM = '32px';
export const CONTROL_HEIGHT = '40px';
export const CONTROL_HEIGHT_LG = '42px';

export const cssVars: Record<string, string> = {
  'color-purple-deep': COLOR_PURPLE_DEEP,
  'color-purple-deep-1': COLOR_PURPLE_DEEP_1,
  'color-purple-deep-2': COLOR_PURPLE_DEEP_2,
  'color-purple-deep-3': COLOR_PURPLE_DEEP_3,
  'color-purple-deep-4': COLOR_PURPLE_DEEP_4,

  'color-purple-light': COLOR_PURPLE_LIGHT,
  'color-purple-light-1': COLOR_PURPLE_LIGHT_1,
  'color-purple-light-2': COLOR_PURPLE_LIGHT_2,
  'color-purple-light-3': COLOR_PURPLE_LIGHT_3,
  'color-purple-light-4': COLOR_PURPLE_LIGHT_4,
  'color-purple-light-soft': COLOR_PURPLE_LIGHT_SOFT,
  'color-purple-light-soft-strong': COLOR_PURPLE_LIGHT_SOFT_STRONG,
  'color-purple-light-border': COLOR_PURPLE_LIGHT_BORDER,

  'color-green': COLOR_GREEN,
  'color-green-1': COLOR_GREEN_1,
  'color-green-2': COLOR_GREEN_2,
  'color-green-3': COLOR_GREEN_3,
  'color-green-4': COLOR_GREEN_4,
  'color-green-soft': COLOR_GREEN_SOFT,
  'color-green-border': COLOR_GREEN_BORDER,

  'color-periwinkle': COLOR_PERIWINKLE,
  'color-periwinkle-1': COLOR_PERIWINKLE_1,
  'color-periwinkle-2': COLOR_PERIWINKLE_2,
  'color-periwinkle-3': COLOR_PERIWINKLE_3,
  'color-periwinkle-4': COLOR_PERIWINKLE_4,
  'color-periwinkle-soft': COLOR_PERIWINKLE_SOFT,
  'color-periwinkle-border': COLOR_PERIWINKLE_BORDER,

  'color-yellow': COLOR_YELLOW,
  'color-yellow-1': COLOR_YELLOW_1,
  'color-yellow-2': COLOR_YELLOW_2,
  'color-yellow-3': COLOR_YELLOW_3,
  'color-yellow-4': COLOR_YELLOW_4,
  'color-yellow-soft': COLOR_YELLOW_SOFT,
  'color-yellow-border': COLOR_YELLOW_BORDER,

  'color-orange': COLOR_ORANGE,
  'color-orange-1': COLOR_ORANGE_1,
  'color-orange-2': COLOR_ORANGE_2,
  'color-orange-3': COLOR_ORANGE_3,
  'color-orange-4': COLOR_ORANGE_4,
  'color-orange-soft': COLOR_ORANGE_SOFT,
  'color-orange-border': COLOR_ORANGE_BORDER,

  'color-red': COLOR_RED,
  'color-red-1': COLOR_RED_1,
  'color-red-2': COLOR_RED_2,
  'color-red-3': COLOR_RED_3,
  'color-red-4': COLOR_RED_4,
  'color-red-soft': COLOR_RED_SOFT,
  'color-red-border': COLOR_RED_BORDER,

  'color-neutral': COLOR_NEUTRAL,
  'color-neutral-1': COLOR_NEUTRAL_1,
  'color-neutral-2': COLOR_NEUTRAL_2,
  'color-neutral-3': COLOR_NEUTRAL_3,
  'color-neutral-4': COLOR_NEUTRAL_4,

  'color-primary': COLOR_PRIMARY,
  'color-primary-hover': COLOR_PRIMARY_HOVER,
  'color-primary-active': COLOR_PRIMARY_ACTIVE,
  'color-primary-light': COLOR_PRIMARY_LIGHT,
  'color-secondary': COLOR_SECONDARY,
  'color-secondary-hover': COLOR_SECONDARY_HOVER,
  'color-secondary-active': COLOR_SECONDARY_ACTIVE,
  'color-accent': COLOR_ACCENT,

  'color-success': COLOR_SUCCESS,
  'color-success-light': COLOR_SUCCESS_LIGHT,
  'color-warning': COLOR_WARNING,
  'color-warning-light': COLOR_WARNING_LIGHT,
  'color-error': COLOR_ERROR,
  'color-error-light': COLOR_ERROR_LIGHT,
  'color-info': COLOR_INFO,
  'color-info-light': COLOR_INFO_LIGHT,

  'color-bg-base': COLOR_BG_BASE,
  'color-bg-subtle': COLOR_BG_SUBTLE,
  'color-bg-muted': COLOR_BG_MUTED,
  'color-bg-elevated': COLOR_BG_ELEVATED,
  'color-bg-elevated-solid': COLOR_BG_ELEVATED_SOLID,
  'color-bg-overlay': COLOR_BG_OVERLAY,
  'color-bg-glass': COLOR_BG_GLASS,
  'color-bg-sidebar': COLOR_BG_SIDEBAR,
  'color-bg-modal': COLOR_BG_MODAL,
  'color-bg-table-sticky': COLOR_BG_TABLE_STICKY,
  'color-bg-table-sticky-hover': COLOR_BG_TABLE_STICKY_HOVER,

  'opacity-hover-strong': OPACITY_HOVER_STRONG,

  'color-text-primary': COLOR_TEXT_PRIMARY,
  'color-text-secondary': COLOR_TEXT_SECONDARY,
  'color-text-tertiary': COLOR_TEXT_TERTIARY,
  'color-text-disabled': COLOR_TEXT_DISABLED,
  'color-text-inverted': COLOR_TEXT_INVERTED,
  'color-text-link': COLOR_TEXT_LINK,
  'color-text-link-hover': COLOR_TEXT_LINK_HOVER,

  'color-border-subtle': COLOR_BORDER_SUBTLE,
  'color-border-default': COLOR_BORDER_DEFAULT,
  'color-border-strong': COLOR_BORDER_STRONG,
  'color-border-focus': COLOR_BORDER_FOCUS,

  'font-family-sans': FONT_FAMILY_SANS,
  'font-family-heading': FONT_FAMILY_HEADING,
  'font-family-mono': FONT_FAMILY_MONO,

  'font-size-2xs': FONT_SIZE_2XS,
  'font-size-xs': FONT_SIZE_XS,
  'font-size-sm': FONT_SIZE_SM,
  'font-size-base': FONT_SIZE_BASE,
  'font-size-md': FONT_SIZE_MD,
  'font-size-lg': FONT_SIZE_LG,
  'font-size-xl': FONT_SIZE_XL,
  'font-size-2xl': FONT_SIZE_2XL,
  'font-size-3xl': FONT_SIZE_3XL,
  'font-size-4xl': FONT_SIZE_4XL,
  'font-size-5xl': FONT_SIZE_5XL,
  'font-size-nav': FONT_SIZE_NAV,
  'font-size-modal-title': FONT_SIZE_MODAL_TITLE,
  'font-size-display-md': FONT_SIZE_DISPLAY_MD,
  'font-size-display-lg': FONT_SIZE_DISPLAY_LG,
  'font-size-timer': FONT_SIZE_TIMER,
  'font-size-timer-label': FONT_SIZE_TIMER_LABEL,
  'font-size-credit-balance': FONT_SIZE_CREDIT_BALANCE,
  'font-size-credit-unit': FONT_SIZE_CREDIT_UNIT,

  'font-weight-light': FONT_WEIGHT_LIGHT,
  'font-weight-normal': FONT_WEIGHT_NORMAL,
  'font-weight-medium': FONT_WEIGHT_MEDIUM,
  'font-weight-semibold': FONT_WEIGHT_SEMIBOLD,
  'font-weight-bold': FONT_WEIGHT_BOLD,
  'font-weight-extrabold': FONT_WEIGHT_EXTRABOLD,

  'line-height-tight': LINE_HEIGHT_TIGHT,
  'line-height-snug': LINE_HEIGHT_SNUG,
  'line-height-normal': LINE_HEIGHT_NORMAL,
  'line-height-relaxed': LINE_HEIGHT_RELAXED,
  'line-height-loose': LINE_HEIGHT_LOOSE,
  'line-height-display': LINE_HEIGHT_DISPLAY,

  'letter-spacing-tighter': LETTER_SPACING_TIGHTER,
  'letter-spacing-tight': LETTER_SPACING_TIGHT,
  'letter-spacing-normal': LETTER_SPACING_NORMAL,
  'letter-spacing-wide': LETTER_SPACING_WIDE,
  'letter-spacing-wider': LETTER_SPACING_WIDER,
  'letter-spacing-widest': LETTER_SPACING_WIDEST,

  'spacing-0': SPACING_0,
  'spacing-px': SPACING_PX,
  'spacing-0-5': SPACING_0_5,
  'spacing-1': SPACING_1,
  'spacing-1-5': SPACING_1_5,
  'spacing-2': SPACING_2,
  'spacing-2-5': SPACING_2_5,
  'spacing-3': SPACING_3,
  'spacing-3-5': SPACING_3_5,
  'spacing-4': SPACING_4,
  'spacing-5': SPACING_5,
  'spacing-6': SPACING_6,
  'spacing-7': SPACING_7,
  'spacing-8': SPACING_8,
  'spacing-9': SPACING_9,
  'spacing-10': SPACING_10,
  'spacing-11': SPACING_11,
  'spacing-12': SPACING_12,
  'spacing-14': SPACING_14,
  'spacing-16': SPACING_16,
  'spacing-20': SPACING_20,
  'spacing-24': SPACING_24,
  'spacing-28': SPACING_28,
  'spacing-32': SPACING_32,

  'radius-none': RADIUS_NONE,
  'radius-sm': RADIUS_SM,
  'radius-default': RADIUS_DEFAULT,
  'radius-md': RADIUS_MD,
  'radius-lg': RADIUS_LG,
  'radius-xl': RADIUS_XL,
  'radius-2xl': RADIUS_2XL,
  'radius-3xl': RADIUS_3XL,
  'radius-full': RADIUS_FULL,

  'shadow-none': SHADOW_NONE,
  'shadow-xs': SHADOW_XS,
  'shadow-sm': SHADOW_SM,
  'shadow-default': SHADOW_DEFAULT,
  'shadow-md': SHADOW_MD,
  'shadow-lg': SHADOW_LG,
  'shadow-xl': SHADOW_XL,
  'shadow-inner': SHADOW_INNER,
  'shadow-table-sticky': SHADOW_TABLE_STICKY,
  'shadow-focus-ring': SHADOW_FOCUS_RING,
  'shadow-glow-primary': SHADOW_GLOW_PRIMARY,
  'shadow-glow-success': SHADOW_GLOW_SUCCESS,
  'shadow-glow-info': SHADOW_GLOW_INFO,
  'shadow-glow-danger': SHADOW_GLOW_DANGER,

  'glass-surface': GLASS_SURFACE,
  'glass-border-color': GLASS_BORDER_COLOR,
  'glass-shadow': GLASS_SHADOW,
  'glass-ring': GLASS_RING,
  'glass-ring-opacity': GLASS_RING_OPACITY,
  'glass-blur': GLASS_BLUR,
  'glass-tint': GLASS_TINT,

  'z-dropdown': Z_INDEX_DROPDOWN,
  'z-sticky': Z_INDEX_STICKY,
  'z-fixed': Z_INDEX_FIXED,
  'z-modal-backdrop': Z_INDEX_MODAL_BACKDROP,
  'z-modal': Z_INDEX_MODAL,
  'z-popover': Z_INDEX_POPOVER,
  'z-tooltip': Z_INDEX_TOOLTIP,
  'z-toast': Z_INDEX_TOAST,

  'transition-duration-fast': TRANSITION_DURATION_FAST,
  'transition-duration-default': TRANSITION_DURATION_DEFAULT,
  'transition-duration-slow': TRANSITION_DURATION_SLOW,
  'transition-duration-slower': TRANSITION_DURATION_SLOWER,
  'transition-duration-chart': TRANSITION_DURATION_CHART,
  'transition-timing-default': TRANSITION_TIMING_DEFAULT,
  'transition-timing-linear': TRANSITION_TIMING_LINEAR,
  'transition-timing-in': TRANSITION_TIMING_IN,
  'transition-timing-out': TRANSITION_TIMING_OUT,
  'transition-timing-bounce': TRANSITION_TIMING_BOUNCE,
  'transition-timing-spring': TRANSITION_TIMING_SPRING,

  'container-sm': CONTAINER_SM,
  'container-md': CONTAINER_MD,
  'container-lg': CONTAINER_LG,
  'container-xl': CONTAINER_XL,
  'container-2xl': CONTAINER_2XL,
  'container-content': CONTAINER_CONTENT,
  'sidebar-width-collapsed': SIDEBAR_WIDTH_COLLAPSED,
  'sidebar-width-expanded': SIDEBAR_WIDTH_EXPANDED,
  'header-height': HEADER_HEIGHT,
  'header-height-compact': HEADER_HEIGHT_COMPACT,

  'control-height-xs': CONTROL_HEIGHT_XS,
  'control-height-sm': CONTROL_HEIGHT_SM,
  'control-height': CONTROL_HEIGHT,
  'control-height-lg': CONTROL_HEIGHT_LG,
};

export function generateCSSVars(): string {
  const cssLines = Object.entries(cssVars).map(([key, value]) => `  --${key}: ${value};`);
  return `:root {\n${cssLines.join('\n')}\n}`;
}
